// @ts-nocheck
import {
    getBlogCategoryArticlesDataView,
    getBlogCategoryFeaturedArticleDataView,
} from "@store/Framework/Store/Data/BlogCategory/BlogCategorySelectors";
import convertSelectorToHook from "@toolkit/Framework/Common/Utilities/convertSelectorToHook";

export const useBlogCategoryArticlesDataView = convertSelectorToHook(getBlogCategoryArticlesDataView);

export const useBlogCategoryFeaturedArticleDataView = convertSelectorToHook(getBlogCategoryFeaturedArticleDataView);
